import React, {useMemo} from 'react';
import {EditableComponentProps, useEditableComponent} from './editableComponent';
import classNames from 'classnames';

interface Props extends EditableComponentProps {
    headerType?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
    extra?: string
}

export default function EditableHeader(props: Props) {
    const {textKey, className, headerType, extra} = props;
    const [content, onChange, editable] = useEditableComponent(textKey);
    const componentProps = {
        contentEditable: editable,
        className,
        onInput: onChange,
        dangerouslySetInnerHTML: {__html: content}
    };
    const renderContent = useMemo(() => {
        if (!extra) return content;
        return content + extra;
    }, [content, extra]);

    // Start checking for h2, we default to h1
    if (headerType === 'h2')
        return <h2 {...componentProps}/>;
    else if (headerType === 'h3')
        return <h3 {...componentProps}/>;
    else if (headerType === 'h4')
        return <h4 {...componentProps}/>;
    else if (headerType === 'h5')
        return <h5 {...componentProps}/>;
    else if (headerType === 'h6')
        return <h6 {...componentProps}/>;

    return (
        <h1 contentEditable={editable} className={classNames('editable-component', 'editable-header', className)}
            onInput={onChange}
            dangerouslySetInnerHTML={{__html: renderContent}}/>
    );
}